import React from "react";
import DocViewer from "./DocViewer";
import { Api } from "../api";
import { useSnackbar } from "notistack";

interface IProps {
  documentId: string;
  preview?: boolean;
  onContinue?: () => void;
  handleUrlLoaded?: (documentUrl: string) => void;
}
export default function DocumentPreview(props: IProps) {
  const { documentId, preview, onContinue, handleUrlLoaded } = props;
  const [url, setUrl] = React.useState();
  const { enqueueSnackbar } = useSnackbar();

  React.useEffect(() => {
    if (documentId) {
      Api.documents.getUrl(documentId).then(result => {
        setUrl(result?.data?.data ?? "");

        if (handleUrlLoaded) {
          handleUrlLoaded(result?.data?.data ?? "")
        }
      });
    }
  }, [documentId, enqueueSnackbar, handleUrlLoaded]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex"
      }}
    >
      {url ? (
        <DocViewer
          source={url}
          preview={preview ?? true}
          onContinue={onContinue}
        />
      ) : null}
    </div>
  );
}
